export default {
    studentLessons: [],
    studentTexts: [],
    studentActivitiesReply: [],
    studentActivitiesNoReply: [],
    studentPollsNoReply: [],
    studentPollsReply: []
}